<template>
  <div class=" StartH Ecosystem-huan" style="height:800px;">
    <!-- 初创企业总数 -->
    <p class="data-title" style="">项目分布</p>

    <div id="myChart5" :style="{ width: '100%', height: '300px' }">
      <router-view></router-view>
    </div>

    <p class="p-list"
      :class="changeColor(value.name)"
      :key="index"
      v-for="(value, index) in data5"
    >
      {{ value.name }}
      <small>({{ value.value }}%)</small>
    </p>
  </div>
</template>
<script>
export default {
  name: "StartH",
  props: { msg: Array },
  data() {
    return {
      starthy: [],
      color: [],
      data5: [
        {
          value: 15.69,
          name: "物联网",
        },
        {
          value: 14.44,
          name: "移动出行",
        },
        {
          value: 12.41,
          name: "供应链物流",
        },
        {
          value: 9.94,
          name: "品牌与零售",
        },
        {
          value: 8.46,
          name: "地产科技",
        },
        {
          value: 8.01,
          name: "医疗健康",
        },
        {
          value: 7.23,
          name: "金融科技",
        },
        {
          value: 7.08,
          name: "保险科技",
        },
        {
          value: 5.76,
          name: "能源与可持续",
        },
        {
          value: 3.78,
          name: "旅游与酒店",
        },
        {
          value: 2.72,
          name: "农业",
        },
      ],
    };
  },
  watch: {
    msg(val) {
      // 传值监听，值变化了才渲染页面
      console.log(val);

      let self = this;
      for (let i = 0; i < val.length; i++) {
        switch (val[i].name) {
          case "保险科技":
            self.color.push("#7e293e");
            break;
          case "物联网":
            self.color.push("#135A2E");
            break;

          case "医疗健康":
            self.color.push("#f09837");
            break;
          case "品牌与零售":
            self.color.push("#e54a41");
            break;
          case "地产科技":
            self.color.push("#4eacc1");
            break;
          case "旅游与酒店":
            self.color.push("#ffcc04");
            break;

          case "移动出行":
            self.color.push("#398190");
            break;
          case "能源与可持续":
            self.color.push("#afc800");
            break;
          case "金融科技":
            self.color.push("#4777e5");
            break;
          case "农业":
            self.color.push("#1e862f");
            break;
          case "供应链物流":
            self.color.push("#32749a");
            break;
          case "待更新":
            self.color.push("#4777e5");
            break;
          default:
            self.color.push("#4777e5");
            break;
        }
      }

      this.drawLine5();
    },
  },
  mounted() {
    this.drawLine5();
  },
  methods: {
    drawLine5() {
      let self = this;
      let val = self.data5;
      console.log("val", val);

      for (let i = 0; i < val.length; i++) {
        switch (val[i].name) {
          case "保险科技":
            self.color.push("#7e293e");
            break;
          case "物联网":
            self.color.push("#135A2E");
            break;

          case "医疗健康":
            self.color.push("#f09837");
            break;
          case "品牌与零售":
            self.color.push("#e54a41");
            break;
          case "地产科技":
            self.color.push("#4eacc1");
            break;
          case "旅游与酒店":
            self.color.push("#ffcc04");
            break;

          case "移动出行":
            self.color.push("#398190");
            break;
          case "能源与可持续":
            self.color.push("#afc800");
            break;
          case "金融科技":
            self.color.push("#4777e5");
            break;
          case "农业":
            self.color.push("#1e862f");
            break;
          case "供应链物流":
            self.color.push("#32749a");
            break;
          case "待更新":
            self.color.push("#4777e5");
            break;
          default:
            self.color.push("#4777e5");
            break;
        }
      }

      // 基于准备好的dom，初始化echarts实例
      let myChart5 = this.$echarts.init(document.getElementById("myChart5"));
      // 绘制图表
      myChart5.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {d}%",
        },
        legend: {
          show: false,
          orient: "vertical",
          x: "left",
          data: [
            "保险科技",
            "供应链与物流",
            "健康",
            "品牌与零售",
            "地产科技",
            "旅游与酒店",
            "早期投资",
            "移动出行",
            "能源与可持续",
            "金融科技",
          ],
        },
        series: [
          {
            name: "行业及占比",
            type: "pie",
            radius: ["70%", "120%"],
            left: "center", //调整位置居中
            top: "center", //调整位置居中
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center",
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "20",
                  fontWeight: "bold",
                },
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            color: self.color,
            data: self.data5,
          },
        ],
      });
      window.addEventListener("resize", function() {
        myChart5.resize();
      });
    },

    changeColor: function(name) {
      switch (name) {
        case "保险科技":
          return "p-huan dian dian-bxkj";
          // eslint-disable-next-line no-unreachable
          break;
        case "物联网":
          return "p-huan dian dian-wlw";
          // eslint-disable-next-line no-unreachable
          break;
        case "供应链与物流":
          return "p-huan dian dian-gyl";
          // eslint-disable-next-line no-unreachable
          break;
        case "医疗健康":
          return "p-huan dian dian-jk";
          // eslint-disable-next-line no-unreachable
          break;
        case "品牌与零售":
          return "p-huan dian dian-ppyls";
          // eslint-disable-next-line no-unreachable
          break;
        case "地产科技":
          return "p-huan dian dian-dckj";
          // eslint-disable-next-line no-unreachable
          break;
        case "旅游与酒店":
          return "p-huan dian dian-lyyjd";
          // eslint-disable-next-line no-unreachable
          break;
        case "早期投资":
          return "p-huan dian ";
          // eslint-disable-next-line no-unreachable
          break;
        case "移动出行":
          return "p-huan dian dian-ydcx";
          // eslint-disable-next-line no-unreachable
          break;
        case "能源与可持续":
          return "p-huan dian dian-nyykcx";
          // eslint-disable-next-line no-unreachable
          break;
        case "金融科技":
          return "p-huan dian dian-jrkj";
          // eslint-disable-next-line no-unreachable
          break;
        case "农业":
          return "p-huan dian dian-ny";
          // eslint-disable-next-line no-unreachable
          break;
        case "供应链物流":
          return "p-huan dian dian-gyl";
          // eslint-disable-next-line no-unreachable
          break;
        case "待更新":
          return "p-huan dian dian-jrkj";
          // eslint-disable-next-line no-unreachable
          break;
        default:
          return "p-huan dian dian-jrkj";
          // eslint-disable-next-line no-unreachable
          break;
      }

      //
    },
  },
};
</script>

<style scoped>
.StartH {
  background: #fff;
  padding: 10px 20px 20px 20px;
  border-radius: 20px;
  margin-top: 20px;
}
.data-title {
  font-size: 24px;
  color: #333;
  font-weight: 600;
  margin-left: 0;
  padding-top: 16px;
}
.Ecosystem-huan .p-huan::before {
  content: "";
  width: 16px;
  height: 16px;
  display: inline-block;
  border-radius: 50%;
  margin-right: 0.5rem;
  /* background-color: #4777e5; */
}
.p-list {
  margin: 1em 0 1em 1em;
}
.dian-wlw::before {
  background-color: #135a2e; /*物联网*/
}
.dian-ny::before {
  background-color: #1e862f; /*农业*/
}
.dian-lyyjd::before {
  background-color: #ffcc04; /*旅游酒店*/
}

.dian-ppyls::before {
  background-color: #e54a41; /*品牌与零售*/
}

.dian-bxkj::before {
  background-color: #7e293e; /*保险科技*/
}

.dian-jrkj::before {
  background-color: #4777e5; /*金融科技*/
}

.dian-jk::before {
  background-color: #f09837; /*医疗与健康*/
}

.dian-nyykcx::before {
  background-color: #afc800; /*能源与可持续*/
}

.dian-dckj::before {
  background-color: #4eacc1; /*地产科技*/
}

.dian-gyl::before {
  background-color: #32749a; /*供应链*/
}

.dian-ydcx::before {
  background-color: #398190; /*移动出行*/
}
/*鏁版嵁鐪嬫澘鐨勭偣*/
</style>
